export default __webpack_public_path__ + "static/media/Montserrat-Regular.3de8eefa.woff2";